import { getConfigName } from "@helpers/funciones";
import { waitingRoomPorEmpresa } from "@helpers/waitingRoomConfig";
import { WaitingRoom } from "./WaitingRoom";

/**
 * Monta la sala de espera del tenant (ver `waitingRoomPorEmpresa`) o, si no tiene una propia, la
 * genérica `WaitingRoom`.
 */
export const WaitingRoomPorEmpresa = () => {
  const Component = waitingRoomPorEmpresa[getConfigName(window.location.href)] ?? WaitingRoom;
  return <Component />;
};
